var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 6,
    viewBox: "0 0 230 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 2.5C0.723858 2.5 0.5 2.72386 0.5 3C0.5 3.27614 0.723858 3.5 1 3.5L1 2.5ZM224.333 3.00002C224.333 4.47278 225.527 5.66669 227 5.66669C228.473 5.66669 229.667 4.47278 229.667 3.00002C229.667 1.52726 228.473 0.333353 227 0.333353C225.527 0.333353 224.333 1.52726 224.333 3.00002ZM1 3.5L227 3.50002L227 2.50002L1 2.5L1 3.5Z",
    fill: "#00E194"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineIcon);
export default __webpack_public_path__ + "static/media/lineIcon.b1e983bd193e4f14b778c7ff925a54dd.svg";
export { ForwardRef as ReactComponent };